import {Action, createAction, props} from '@ngrx/store';
import {ICommodities} from '../models/ICommodityModel';
import {IStates} from '../models/IStatesModel';

export enum CommodityActionTypes {
  RETRIEVE_COMMODITIES = '[ICommodity] RetrieveCommodities',
  COMMODITIES_RECEIVED = '[ICommodity] ReceivedCommodities'
}

export const RetrieveCommoditiesAction = createAction(
  CommodityActionTypes.RETRIEVE_COMMODITIES,
  props<{ stateCode: IStates; year: number }>()
);

export const CommoditiesReceivedAction = createAction(
  CommodityActionTypes.COMMODITIES_RECEIVED,
  props<{ commodities: Array<ICommodities> }>()
);

// export class RetrieveCommoditiesAction implements Action {
//   readonly type = CommodityActionTypes.RETRIEVE_COMMODITIES;
//
//   constructor(public payload: { stateCode: number, year: number }) {
//
//   }
// }
//
// export class CommoditiesReceivedAction implements Action {
//   readonly type = CommodityActionTypes.COMMODITIES_RECEIVED;
//
//   constructor(public payload: Array<ICommodities>) {
//
//   }
// }
